import React from 'preact/compat';
import { useState } from 'preact/hooks';

import Stack from '@mui/material/Stack';
import IconButton from "@mui/material/IconButton";
import TextField from '@mui/material/TextField';

import colors from '../colors';
import CloseIcon from '../icons/CloseIcon';
import SearchIcon from '../icons/SearchIcon';

const LauncherFeatureFilterField = ({value, setValue, changeDelay=300}) => {
    const [lastTimeout, setLastTimeout] = useState(null);
    const [lastValue, setLastValue] = useState(null);

    const onChange = (e) => {
        const value = e.target.value;
        clearTimeout(lastTimeout);
        setLastValue(value);
        const timeout = setTimeout(() => {
            setValue(value);
        }, changeDelay);
        setLastTimeout(timeout);
    }

    const onClearField = (e) => {
        clearTimeout(lastTimeout);
        setLastValue(null);
        setValue('');
    }

    return <Stack
        direction="row"
        spacing="16px"
        sx={{
            justifyContent: 'stretch',
            margin: '24px',
            marginTop: '32px',
            backgroundColor: colors.inputBackground,
            height: '40px',
            borderRadius: '8px',
            alignItems: 'center',
            padding: '0.2em',
            '& svg': {
                width: '24px'
            }
        }}
    >
        <IconButton sx={{color: colors.featureSelectorBackground}} aria-label="search" component="label">
          <SearchIcon sx={{stroke: colors.inputImage }}/>
        </IconButton>
        <TextField
            id="feature-filter"
            placeholder="Search"
            variant="standard"
            value={lastValue !== null ? lastValue : value}
            onChange={onChange}
            sx={{
                fontSize: '16px',
                flexGrow: 1,
                '& .MuiInputBase-root::before': {
                    borderWidth: 0,
                    borderColor: colors.optionHover
                },
                '&:hover .MuiInputBase-root::before': {
                    borderColor: colors.optionHover
                },
                '& .MuiInputBase-root::after': {
                    borderColor: colors.option
                },
                '& .MuiInputBase-input': {
                    marginTop: '4px',
                    paddingBottom: '3px',
                    color: colors.inputText,
                    fontWeight: 400
                },
            }}
        />
        <IconButton sx={{color: colors.featureSelectorBackground}}
                aria-label="clear search field" component="label"
                onClick={onClearField}
            >
            <CloseIcon stroke={colors.inputImage} />
        </IconButton>
    </Stack>;
};

export default LauncherFeatureFilterField;
